/* unplugin-vue-components disabled */import { render } from "./speechComp.vue?vue&type=template&id=1b490688&scoped=true"
import script from "./speechComp.vue?vue&type=script&lang=js"
export * from "./speechComp.vue?vue&type=script&lang=js"

import "./speechComp.vue?vue&type=style&index=0&id=1b490688&scoped=true&lang=stylus"

import exportComponent from "/var/jenkins_home/workspace/JOINMC-H5-HTML-MASTER/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b490688"]])

export default __exports__